import{gql as o}from"@apollo/client";const e=o`
  query getTemporaryToken {
    getTemporarySession
  }
`;export{e as GET_TEMPORARY_TOKEN_QUERY};
//# sourceMappingURL=useTemporaryToken.graphql.js.map
